<div *ngIf="!hidden" class="componentWrapper" id="{{component.id}}">
    <div class="alert alert-success alert-dismissible fade show" [ngClass]="{'stretchToFit': hasOptionValue(component, 'isFitScreen', true)}">
        <button type="button" class="close" data-dismiss="alert">&times;</button>
        <ng-container *ngIf="hasOptionKey('iconName')">
            <mat-icon>{{getOptionByKey('iconName')}}</mat-icon>
        </ng-container>
        {{label}}
    </div>
</div>
